import './tooltip.css';
export default {
  "modifiers": {
    "top": "pf-m-top",
    "topLeft": "pf-m-top-left",
    "topRight": "pf-m-top-right",
    "bottom": "pf-m-bottom",
    "bottomLeft": "pf-m-bottom-left",
    "bottomRight": "pf-m-bottom-right",
    "left": "pf-m-left",
    "leftTop": "pf-m-left-top",
    "leftBottom": "pf-m-left-bottom",
    "right": "pf-m-right",
    "rightTop": "pf-m-right-top",
    "rightBottom": "pf-m-right-bottom",
    "textAlignLeft": "pf-m-text-align-left"
  },
  "themeDark": "pf-v5-theme-dark",
  "tooltip": "pf-v5-c-tooltip",
  "tooltipArrow": "pf-v5-c-tooltip__arrow",
  "tooltipContent": "pf-v5-c-tooltip__content"
};